export var CombatLogActionType;
(function (CombatLogActionType) {
    CombatLogActionType["DAMAGE"] = "damage";
    CombatLogActionType["HEAL"] = "heal";
    CombatLogActionType["STATUS_EFFECT"] = "status_effect";
    CombatLogActionType["AREA_EFFECT"] = "area_effect";
    CombatLogActionType["NEXT_ROUND"] = "next_round";
    CombatLogActionType["NEXT_TURN"] = "next_turn";
    CombatLogActionType["OTHER"] = "other";
    CombatLogActionType["MESSAGE"] = "message";
})(CombatLogActionType || (CombatLogActionType = {}));
